import { render, staticRenderFns } from "./ItemSound.vue?vue&type=template&id=5ba29f00&scoped=true&"
import script from "./ItemSound.vue?vue&type=script&lang=js&"
export * from "./ItemSound.vue?vue&type=script&lang=js&"
import style0 from "./ItemSound.vue?vue&type=style&index=0&id=5ba29f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba29f00",
  null
  
)

export default component.exports